import { lazy } from "react";
import { Navigate } from "react-router-dom";

import Home from "./pages/Home";
import Profile from "./pages/Profile";
import OwnPost from "./pages/OwnPost";
import CommunityInfo from "./pages/CommunityInfo";
import CommunityPosts from "./pages/CommunityPosts";
import Saved from "./pages/Saved";
import PrivatePosts from "./pages/PrivatePosts";
import PublicProfile from "./pages/PublicProfile";
import AllCommunities from "./pages/AllCommunities";
import MyCommunities from "./pages/MyCommunities";
import Following from "./pages/Following";
import SkillsCircleFollowers from "./pages/SkillsCircleFollowers";
import SkillsCircleFollowing from "./pages/SkillsCircleFollowing";
import ReceivedProfileViewRequests from "./pages/ReceivedProfileViewRequests";
import SentProfileViewRequests from "./pages/SentProfileViewRequests";
import ReceivedFollowRequests from "./pages/ReceivedFollowRequests";
import MySkillsCommunities from "./pages/MySkillsCommunities";
import SuggestedCommunities from "./pages/SuggestedCommunities";
import Search from "./pages/Search";
import MyCommunityDetail from "./pages/MyCommunityDetail";
import Events from "./pages/Events";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import AccountCenter from "./pages/AccountCenter";
import PostOrProfile from "./pages/PostOrProfile";
import Notifications from "./pages/Notifications";

// Redirect component for community routes
// const CommunityRedirect = () => {
//   const { communityName } = useParams();
//   return <Navigate to={`/community/${communityName}/info`} replace />;
// };

const ReportedPost = lazy(() => import("./pages/ReportedPost"));
const Moderator = lazy(() => import("./pages/Moderator"));
const DevicesLocations = lazy(() => import("./pages/DevicesLocations"));
const VerifyEmail = lazy(() => import("./pages/VerifyEmail"));
const EmailVerifiedMessage = lazy(() => import("./pages/EmailVerifiedMessage"));
const BlockDevice = lazy(() => import("./pages/BlockDevice"));
const LoginVerified = lazy(() => import("./pages/LoginVerified"));
const AccessDenied = lazy(() => import("./pages/AccessDenied"));
const NotFound = lazy(() => import("./pages/NotFound"));

// OAuth Authentication Components
const AuthOAuth = lazy(() => import("./pages/AuthOAuth"));
const SSOCallback = lazy(() => import("./pages/SSOCallback"));

export const privateRoutes = [
  {
    path: "/",
    element: <Navigate to="/skills-feed" replace />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/skills-feed",
    element: <Home />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/my/post/:postId",
    element: <OwnPost />,
  },
  {
    path: "/skills-feed/:communityName",
    element: <CommunityInfo />,
  },
  // {
  //   path: "/community/:communityName/info",
  //   element: <CommunityInfo />,
  // },
  {
    path: "/skills-feed/:communityName/posts",
    element: <CommunityPosts />,
  },
  {
    path: "/skills-feed/:communityName/reported-post",
    element: <ReportedPost />,
  },
  {
    path: "/skills-feed/:communityName/moderator",
    element: <Moderator />,
  },
  {
    path: "/skills-feed/saved",
    element: <Saved />,
  },
  {
    path: "/skills-feed/private",
    element: <PrivatePosts />,
  },
  // NOTE: `/post/:slug` is handled as a public route via `PostOrProfile`
  {
    path: "/communities",
    element: <AllCommunities />,
  },
  {
    path: "/my-communities",
    element: <MyCommunities />,
  },
  {
    path: "/skills-feed/following",
    element: <Following />,
  },
  {
    path: "/skills-circle",
    element: <Navigate to="/skills-circle/received-follow-requests" replace />,
  },
  {
    path: "/skills-circle/followers",
    element: <SkillsCircleFollowers />,
  },
  {
    path: "/skills-circle/following",
    element: <SkillsCircleFollowing />,
  },
  {
    path: "/skills-circle/received-profile-requests",
    element: <ReceivedProfileViewRequests />,
  },
  {
    path: "/skills-circle/sent-profile-requests",
    element: <SentProfileViewRequests />,
  },
  {
    path: "/skills-circle/received-follow-requests",
    element: <ReceivedFollowRequests />,
  },
  {
    path: "/skills-communities/my-communities",
    element: <MySkillsCommunities />,
  },
  {
    path: "/skills-communities/suggested",
    element: <SuggestedCommunities />,
  },
  {
    path: "/skills-communities/:communityName",
    element: <MyCommunityDetail />,
  },
  {
    path: "/skills-feed/search",
    element: <Search />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/my-skills-communities",
    element: <Navigate to="/skills-communities/my-communities" replace />,
  },
  {
    path: "/skillscommunities/mycommunities",
    element: <Navigate to="/skills-communities/my-communities" replace />,
  },
  {
    path: "/events",
    element: <Events />,
  },
  {
    path: "/devices-locations",
    element: <DevicesLocations />,
  },
  {
    path: "/account-center",
    element: <AccountCenter />,
  },
  {
    path: "/notifications",
    element: <Notifications />,
  },
];

export const publicRoutes = [
  {
    path: "/signup",
    element: <SignUp />,
  },
  {
    path: "/signin",
    element: <SignIn />,
  },
  {
    path: "/auth",
    element: <AuthOAuth />,
  },
  {
    path: "/sso/callback",
    element: <SSOCallback />,
  },
  {
    path: "/auth/verify",
    element: <VerifyEmail />,
  },
  {
    path: "/email-verified",
    element: <EmailVerifiedMessage />,
  },
  {
    path: "/block-device",
    element: <BlockDevice />,
  },
  {
    path: "/verify-login",
    element: <LoginVerified />,
  },
  {
    path: "/access-denied",
    element: <AccessDenied />,
  },
  // Public profiles (Instagram/LinkedIn-style)
  {
    path: "/post/:slug",
    element: <PostOrProfile />,
  },
  {
    path: "/profile/:username",
    element: <PublicProfile />,
  },
  // Backward compatibility
  {
    path: "/user/:userId",
    element: <PublicProfile />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
